/**
 * Типы бэкграундов
 * @type {Object}
 */
export var BACKGROUND_TYPE = {
  solid: 'div-solid-background',
  gradient: 'div-gradient-background',
  image: 'div-image-background'
};